import { render, staticRenderFns } from "./benzm.vue?vue&type=template&id=e8b84b64"
import script from "./benzm.vue?vue&type=script&lang=js"
export * from "./benzm.vue?vue&type=script&lang=js"
import style0 from "./benzm.vue?vue&type=style&index=0&id=e8b84b64&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports